/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AntragsfragenGruppiertMitBedingungen } from '../model/antragsfragen-gruppiert-mit-bedingungen.model';
// @ts-ignore
import { CreateVorgangRequest } from '../model/create-vorgang-request.model';
// @ts-ignore
import { GenerateDeckungsnoteRequest } from '../model/generate-deckungsnote-request.model';
// @ts-ignore
import { SetAntragRequest } from '../model/set-antrag-request.model';
// @ts-ignore
import { SetAntragResponse } from '../model/set-antrag-response.model';
// @ts-ignore
import { Sparte } from '../model/sparte.model';
// @ts-ignore
import { VorgangDocument } from '../model/vorgang-document.model';
// @ts-ignore
import { VorgangResponse } from '../model/vorgang-response.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    WarenkorbServiceInterface,
    CreateVorgangRequestParams,
    ExecuteVorgangGetOrderRequestParams,
    GenerateDeckungsnoteRequestParams,
    GetVorgangRequestParams,
    GetVorgangAntragsfragenRequestParams,
    GetVorgangDokumentInhaltRequestParams,
    GetVorgangDokumenteRequestParams,
    SetAntragRequestParams
} from './warenkorb.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class WarenkorbService extends BaseService implements WarenkorbServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Legt einen Vorgang ohne Preis und Dokumente des Versicherers an
     * Antwortet sofort mit getOrderStatus Unknown, Beträgen null und leerer Dokumentliste; der verbindliche Preis und die Versichererdokumente werden anschließend über ExecuteVorgangGetOrder abgerufen.
     * @endpoint post /api/sparte/{sparte}/vorgang
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createVorgang(requestParameters: CreateVorgangRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VorgangResponse>;
    public createVorgang(requestParameters: CreateVorgangRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VorgangResponse>>;
    public createVorgang(requestParameters: CreateVorgangRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VorgangResponse>>;
    public createVorgang(requestParameters: CreateVorgangRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const sparte = requestParameters?.sparte;
        if (sparte === null || sparte === undefined) {
            throw new Error('Required parameter sparte was null or undefined when calling createVorgang.');
        }
        const createVorgangRequest = requestParameters?.createVorgangRequest;
        if (createVorgangRequest === null || createVorgangRequest === undefined) {
            throw new Error('Required parameter createVorgangRequest was null or undefined when calling createVorgang.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte/${this.configuration.encodeParam({name: "sparte", value: sparte, in: "path", style: "simple", explode: false, dataType: "Sparte", dataFormat: undefined})}/vorgang`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VorgangResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createVorgangRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ruft Preis und Dokumente des Versicherers ab und persistiert sie am Vorgang
     * Führt den Abruf bei Unknown, Error oder verwaistem Loading in diesem Aufruf aus und antwortet erst mit dem Ergebnis. Liefert bei Success das persistierte Ergebnis und bei einem parallel laufenden Abruf den aktuellen Zustand ohne erneuten Anstoß. Ein fehlgeschlagener Abruf wird als getOrderStatus Error zurückgegeben und kann wiederholt werden.
     * @endpoint post /api/sparte/{sparte}/vorgang/{id}/get-order
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public executeVorgangGetOrder(requestParameters: ExecuteVorgangGetOrderRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VorgangResponse>;
    public executeVorgangGetOrder(requestParameters: ExecuteVorgangGetOrderRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VorgangResponse>>;
    public executeVorgangGetOrder(requestParameters: ExecuteVorgangGetOrderRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VorgangResponse>>;
    public executeVorgangGetOrder(requestParameters: ExecuteVorgangGetOrderRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const sparte = requestParameters?.sparte;
        if (sparte === null || sparte === undefined) {
            throw new Error('Required parameter sparte was null or undefined when calling executeVorgangGetOrder.');
        }
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling executeVorgangGetOrder.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte/${this.configuration.encodeParam({name: "sparte", value: sparte, in: "path", style: "simple", explode: false, dataType: "Sparte", dataFormat: undefined})}/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/get-order`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VorgangResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Erzeugt die Deckungsnote aus den Antragsfragen und hängt sie an den Vorgang an
     * @endpoint post /api/sparte/{sparte}/vorgang/{id}/deckungsnote
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public generateDeckungsnote(requestParameters: GenerateDeckungsnoteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<VorgangDocument>>;
    public generateDeckungsnote(requestParameters: GenerateDeckungsnoteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<VorgangDocument>>>;
    public generateDeckungsnote(requestParameters: GenerateDeckungsnoteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<VorgangDocument>>>;
    public generateDeckungsnote(requestParameters: GenerateDeckungsnoteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const sparte = requestParameters?.sparte;
        if (sparte === null || sparte === undefined) {
            throw new Error('Required parameter sparte was null or undefined when calling generateDeckungsnote.');
        }
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling generateDeckungsnote.');
        }
        const generateDeckungsnoteRequest = requestParameters?.generateDeckungsnoteRequest;
        if (generateDeckungsnoteRequest === null || generateDeckungsnoteRequest === undefined) {
            throw new Error('Required parameter generateDeckungsnoteRequest was null or undefined when calling generateDeckungsnote.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte/${this.configuration.encodeParam({name: "sparte", value: sparte, in: "path", style: "simple", explode: false, dataType: "Sparte", dataFormat: undefined})}/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/deckungsnote`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<VorgangDocument>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: generateDeckungsnoteRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ruft einen Vorgang einer Sparte zur Fortsetzung ab
     * Beantwortet auch einen Vorgang, dessen Antrag gerade übermittelt wird oder bereits übermittelt wurde; status nennt den Stand, auch wenn die Antwort des Antragsversands nie ankam.
     * @endpoint get /api/sparte/{sparte}/vorgang/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getVorgang(requestParameters: GetVorgangRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VorgangResponse>;
    public getVorgang(requestParameters: GetVorgangRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VorgangResponse>>;
    public getVorgang(requestParameters: GetVorgangRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VorgangResponse>>;
    public getVorgang(requestParameters: GetVorgangRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const sparte = requestParameters?.sparte;
        if (sparte === null || sparte === undefined) {
            throw new Error('Required parameter sparte was null or undefined when calling getVorgang.');
        }
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getVorgang.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte/${this.configuration.encodeParam({name: "sparte", value: sparte, in: "path", style: "simple", explode: false, dataType: "Sparte", dataFormat: undefined})}/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VorgangResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ruft die Antragsfragen eines Vorgangs mit vorausgefüllten Antworten ab
     * Berechnung und Kombination werden aus dem Vorgang abgeleitet. Die Antworten werden aus dem Task-Entwurf bzw. den beim Erzeugen der Deckungsnote gespeicherten Antworten vorausgefüllt.
     * @endpoint get /api/sparte/{sparte}/vorgang/{id}/antragsfragen
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getVorgangAntragsfragen(requestParameters: GetVorgangAntragsfragenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AntragsfragenGruppiertMitBedingungen>;
    public getVorgangAntragsfragen(requestParameters: GetVorgangAntragsfragenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AntragsfragenGruppiertMitBedingungen>>;
    public getVorgangAntragsfragen(requestParameters: GetVorgangAntragsfragenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AntragsfragenGruppiertMitBedingungen>>;
    public getVorgangAntragsfragen(requestParameters: GetVorgangAntragsfragenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const sparte = requestParameters?.sparte;
        if (sparte === null || sparte === undefined) {
            throw new Error('Required parameter sparte was null or undefined when calling getVorgangAntragsfragen.');
        }
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getVorgangAntragsfragen.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte/${this.configuration.encodeParam({name: "sparte", value: sparte, in: "path", style: "simple", explode: false, dataType: "Sparte", dataFormat: undefined})}/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/antragsfragen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AntragsfragenGruppiertMitBedingungen>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Inhalt eines Dokuments eines Vorgangs einer Sparte abrufen
     * @endpoint get /api/sparte/{sparte}/vorgang/documents/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getVorgangDokumentInhalt(requestParameters: GetVorgangDokumentInhaltRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public getVorgangDokumentInhalt(requestParameters: GetVorgangDokumentInhaltRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public getVorgangDokumentInhalt(requestParameters: GetVorgangDokumentInhaltRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public getVorgangDokumentInhalt(requestParameters: GetVorgangDokumentInhaltRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const sparte = requestParameters?.sparte;
        if (sparte === null || sparte === undefined) {
            throw new Error('Required parameter sparte was null or undefined when calling getVorgangDokumentInhalt.');
        }
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getVorgangDokumentInhalt.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/sparte/${this.configuration.encodeParam({name: "sparte", value: sparte, in: "path", style: "simple", explode: false, dataType: "Sparte", dataFormat: undefined})}/vorgang/documents/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dokumente eines Vorgangs einer Sparte abrufen
     * @endpoint get /api/sparte/{sparte}/vorgang/{id}/documents
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getVorgangDokumente(requestParameters: GetVorgangDokumenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<VorgangDocument>>;
    public getVorgangDokumente(requestParameters: GetVorgangDokumenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<VorgangDocument>>>;
    public getVorgangDokumente(requestParameters: GetVorgangDokumenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<VorgangDocument>>>;
    public getVorgangDokumente(requestParameters: GetVorgangDokumenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const sparte = requestParameters?.sparte;
        if (sparte === null || sparte === undefined) {
            throw new Error('Required parameter sparte was null or undefined when calling getVorgangDokumente.');
        }
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getVorgangDokumente.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte/${this.configuration.encodeParam({name: "sparte", value: sparte, in: "path", style: "simple", explode: false, dataType: "Sparte", dataFormat: undefined})}/vorgang/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/documents`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<VorgangDocument>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Antrag abschließen
     * @endpoint post /api/sparte/{sparte}/antrag-einreichen
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setAntrag(requestParameters: SetAntragRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SetAntragResponse>;
    public setAntrag(requestParameters: SetAntragRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SetAntragResponse>>;
    public setAntrag(requestParameters: SetAntragRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SetAntragResponse>>;
    public setAntrag(requestParameters: SetAntragRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const sparte = requestParameters?.sparte;
        if (sparte === null || sparte === undefined) {
            throw new Error('Required parameter sparte was null or undefined when calling setAntrag.');
        }
        const setAntragRequest = requestParameters?.setAntragRequest;
        if (setAntragRequest === null || setAntragRequest === undefined) {
            throw new Error('Required parameter setAntragRequest was null or undefined when calling setAntrag.');
        }
        const kundeToken = requestParameters?.kundeToken;

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte/${this.configuration.encodeParam({name: "sparte", value: sparte, in: "path", style: "simple", explode: false, dataType: "Sparte", dataFormat: undefined})}/antrag-einreichen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SetAntragResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: setAntragRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
